import { Record } from 'immutable'

export class Customer extends Record({
    id: undefined,
    name: undefined,
    code: undefined,
    street: undefined,
    city: undefined,
    zipcode: undefined,
    country_id: undefined,
    phone: undefined,
    email: undefined,
    reg_number: undefined,
    vat_number: undefined,
    is_blocked: undefined,
    name_transporeon: undefined,
    invoice_deadline_days: undefined,
    email_for_invoicing: undefined,
    limit_unpaid_invoices: undefined,
    limit_overdue_invoices: undefined,
    invoicing_note: undefined,
    invoicing_address: undefined,
    invoicing_addresses: undefined,
    customer_default_bank_accounts: undefined,
    bank_account: undefined,
    bank_code: undefined,
    bank_account_iban: undefined,
    bank_account_swift: undefined,
    default_currency_id: undefined,
    default_invoicing_address_id: undefined,
    business_manager_id: undefined,
    business_manager: undefined,
    dispatcher_id: undefined,
    dispatcher: undefined,
    transport_plan_count: undefined,
    transport_plan_value: undefined,
    transport_plan_margin: undefined,
    spedition_plan_count: undefined,
    spedition_plan_value: undefined,
    spedition_plan_margin: undefined,
    vat_payer: undefined,
    factoring: undefined,
    email_invoicing: undefined,
    deleted_at: undefined,
}) {
    getAddress = () => {
        const parts = []
        this.street && parts.push(this.street)
        this.city && parts.push(this.city)
        this.zipcode && parts.push(this.zipcode)

        return parts.join(', ')
    }

    getBankAccount = () => {
        const parts = []
        this.bank_account && parts.push(this.bank_account)
        this.bank_account && this.bank_code && parts.push(this.bank_code)

        return parts.join('/')
    }
}
